import React, { createContext, useReducer, useEffect, useState } from 'react';
import humps from 'humps';
import moment from 'moment'
import axios from 'axios';
import { getBaseURL } from '../utils/appConfig';
import { API } from '../hooks/apiHook';
// import { API } from '../backend';
// -----------------------------------------------------------

const EventsContext = createContext();
// const loggedUserData = JSON.parse(window.localStorage.getItem('userData'));
// const grpArr = loggedUserData?.groups?.map((obj) => obj.id);

const handlers = {
  USERS_LEVEL: (state, action) => {
    // console.log(action.payload);
    const userLevels = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      userLevels
    };
  }
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

export const EventsProvider = ({ children }) => {
  const accessToken = window.localStorage.getItem('accessToken');
  const initialState = {
    userLevels: [],
    groups: [],
    Teams: [],
    allUsers: []
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [showPreviewComponent, setShowPreviewComponent] = useState(false);
  const [phraseBuilderObj, setPhraseBuilderObj] = useState({
    builder: []
  });

  const [eventsPhraseBuilderListData, setEventsPhraseBuilderListData] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [noOfGroupedBuilders, setNoOfGroupedBuilders] = useState(0);
  const [commonJoint, setCommonJoint] = useState();
  const [newBuilders, setNewBuilders] = useState([]);
  const [updateBuilders, setUpdateBuilders] = useState([]);
  const [deletedBuilderIds, setDeletedBuilderIds] = useState([]);
  // phrase count
  const [phraseCount, setPhraseCount] = useState();
  //
  const [builderName, setBuilderName] = useState();
  const [groupedData, setGroupedData] = useState();
  const [latestUpdatedObj, setLatestUpdatedObj] = useState();
  const [categoryId, setCategoryId] = useState('');
  const [eventDialogOpen, setEventDialogOpen] = useState(false);
  const [eventCallsFilterOpen, setEventCallsFilterOpen] = useState(false);
  const [multipleEventCallsFilterOpen, setMultipleEventCallsFilterOpen] = useState(false);

  const [selectedEvents, setSelectedEvents] = useState([]);
  const [isAddMode, setIsAddMode] = useState(false);

  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [checkEmptyGroup, setCheckEmptyGroup] = useState();
  const [eventBuilderFilterData, setEventBuilderFilterData] = useState();

  const [isAllPreSelected, setIsAllPreSelected] = useState(false);
  const [showDownloadExcel, setShowDownloadExcel] = useState(false);
  const [indBuilderObj, setIndBuilderObj] = useState();
  const [page, setPage] = useState(1);
  // Location data
  const [locationFormData, setLocationFormData] = useState({
    durationType: '',
    callDurationStart: 0,
    callDurationEnd: 0
  });
  // ----------------------------------------------------------------------------------------------

  const exportEvents = async (events, pageNo) => {
    console.log(events)
    const accessToken = window.localStorage.getItem('accessToken');
    // setShowSpinner(true);

    // It's important to set the correct headers and responseType for binary data.
    const headers = { 'Authorization': `Token ${accessToken}` };
    const config = {
      method: 'POST',
      url: `/analyze/preview_event?page=${pageNo}`,
      data: humps.decamelizeKeys(events),
      responseType: 'arraybuffer',
      headers
    };

    try {
      const response = await API(config);

      const currentDateTime = moment(Date.now()).format('MMMM Do YYYY, h:mm:ss a');
      const outputFilename = `Export - ${currentDateTime}.xlsx`;

      // setShowSpinner(false);
      // If you want to download file automatically using link attribute.
      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      // OR you can save/write file locally.
      // fs.writeFileSync(outputFilename, response.data);
    } catch (error) {
      // setShowSpinner(false);
      throw Error(error);
    }
  }

  return (
    <EventsContext.Provider
      value={{
        showPreviewComponent,
        setShowPreviewComponent,
        phraseBuilderObj,
        setPhraseBuilderObj,
        eventsPhraseBuilderListData,
        setEventsPhraseBuilderListData,
        showAlert,
        setShowAlert,
        noOfGroupedBuilders,
        setNoOfGroupedBuilders,
        newBuilders,
        setNewBuilders,
        updateBuilders,
        setUpdateBuilders,
        deletedBuilderIds,
        setDeletedBuilderIds,
        phraseCount,
        setPhraseCount,
        builderName,
        setBuilderName,
        groupedData,
        setGroupedData,
        latestUpdatedObj,
        setLatestUpdatedObj,
        categoryId,
        setCategoryId,
        isAddMode,
        setIsAddMode,
        eventDialogOpen,
        setEventDialogOpen,
        unsavedChanges,
        setUnsavedChanges,
        commonJoint,
        setCommonJoint,
        checkEmptyGroup,
        setCheckEmptyGroup,
        eventBuilderFilterData,
        setEventBuilderFilterData,
        eventCallsFilterOpen,
        setEventCallsFilterOpen,
        isAllPreSelected, setIsAllPreSelected,
        indBuilderObj, setIndBuilderObj,
        page, setPage,
        multipleEventCallsFilterOpen,
        setMultipleEventCallsFilterOpen,
        selectedEvents, setSelectedEvents,
        exportEvents,
        showDownloadExcel,
        setShowDownloadExcel,
        locationFormData, setLocationFormData
      }}
    >
      {children}
    </EventsContext.Provider>
  );
};

export default EventsContext;
